import React, { Component } from 'react';
import RangePickerClient from "../RangePickerClient";
import { timeFunctionTranslater } from '@platform/api';

class RangePickerTranslate extends Component {
    constructor(props){
        super(props);
        this.onChange = this.onChange.bind(this);
    }
    onChange(date, display){
        const { onChange } = this.props;
        if(onChange&&Array.isArray(date)){
            var res = date.map(item=>{return timeFunctionTranslater(item)})
            onChange(date, res, display);// 原值 翻译值 display
        }   
    }
    render(){
        return <RangePickerClient {...this.props} onChange={this.onChange}/>
    }
}
export default RangePickerTranslate; 

